
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class ClientTableDialog extends Serenity.EntityDialog<ClientTableRow, any> {
        protected getFormKey() { return ClientTableForm.formKey; }
        protected getIdProperty() { return ClientTableRow.idProperty; }
        protected getLocalTextPrefix() { return ClientTableRow.localTextPrefix; }
        protected getNameProperty() { return ClientTableRow.nameProperty; }
        protected getService() { return ClientTableService.baseUrl; }

        protected form = new ClientTableForm(this.idPrefix);

        constructor() {
            super();

            this.form.ExistingTable.changeSelect2(e => {
                this.form.TableSchema.value = Q.replaceAll(Q.replaceAll(
                    this.form.ExistingTable.value || '', '[', ''), ']', '').split('.')[0];
                this.form.Tablename.value = Q.replaceAll(Q.replaceAll(
                    this.form.ExistingTable.value || '', '[', ''), ']', '').split('.')[1];
                
                this.tableNameChanged();
                this.updateInterface();
            });

            this.form.Tablename.change(e => {
                this.tableNameChanged();
            });
        }

        private tableNameChanged() {
            this.form.Identifier.value = camelize(this.form.Tablename.value || '');
            this.form.DisplayName.value = titleize(this.form.Tablename.value || '');
            this.form.InstanceName.value = titleize(this.form.Tablename.value || '');
        }

        protected updateInterface() {
            super.updateInterface();

            this.form.ExistingTable.getGridField().toggle(this.isNew());

            var existingTable = this.isNew() && !!this.form.ExistingTable.value;
            Serenity.EditorUtils.setReadOnly(this.form.TableSchema, existingTable);
            Serenity.EditorUtils.setReadOnly(this.form.Tablename, existingTable);
            Serenity.EditorUtils.setRequired(this.form.ExistingTable, existingTable);
            Serenity.EditorUtils.setRequired(this.form.TableSchema, !existingTable);
            Serenity.EditorUtils.setRequired(this.form.Tablename, !existingTable);
        }

        // required to keep table dropdown selected when renaming table
        private newEntityId: string;

        protected getSaveEntity() {
            var se = super.getSaveEntity();
            this.newEntityId = '[' + se.TableSchema + '].[' + se.Tablename + ']';
            se.ImportedTable = this.isNew() && !!this.form.ExistingTable.value;
            return se;
        }

        protected getSaveOptions(callback) {
            var opt = super.getSaveOptions(callback);
            var oldOnSuccess = opt.onSuccess;
            opt.onSuccess = (response) => {
                if (this.isEditMode())
                    this.entityId = this.newEntityId;
                oldOnSuccess(response);
            }
            return opt;
        }
    }

    export function camelize(str: string) {
        var str_arr = str.split('_');
        for (var x = 0; x < str_arr.length; x++)
            str_arr[x] = str_arr[x].charAt(0).toUpperCase() + str_arr[x].substring(1);
        return str_arr.join('');
    }

    export function titleize(str: string) {
        var str_arr = str.split('_');
        for (var x = 0; x < str_arr.length; x++)
            str_arr[x] = str_arr[x].charAt(0).toUpperCase() + str_arr[x].substring(1);
        return str_arr.join(' ');
    }
}